import { z } from "zod";

import { Intent } from "@/shared/agent-prompts/workflow-types";

/** A request screen permits intake; only booked-appointment evidence can authorize an action. */
export enum SchedulingScopeStage {
  BookedAppointment = "booked_appointment",
  CallerRequest = "caller_request",
}

/** Admission permits lookup, never an action on an appointment. */
export enum SchedulingRequestAdmissionDecision {
  ProceedToLookup = "proceed_to_lookup",
  Transfer = "transfer",
}

export enum SchedulingUnspecifiedServiceHandling {
  LookupAppointment = "lookup_appointment",
}

export const schedulingRequestAdmissionPolicySchema = z.strictObject({
  reschedule: z.strictObject({ unspecifiedService: z.enum(SchedulingUnspecifiedServiceHandling) }).optional(),
});

export type SchedulingRequestAdmissionPolicy = z.infer<typeof schedulingRequestAdmissionPolicySchema>;

export const scopeRequestedIntentSchema = z
  .enum([
    Intent.CancelAppointment,
    Intent.ConfirmAppointment,
    Intent.LeaveMessage,
    Intent.Reschedule,
    Intent.Unconfirmed,
  ])
  .nullable()
  .describe(
    "The caller's explicitly requested workflow, independently from any clinical reason: explicitly reschedule or move an existing appointment to another date/time=reschedule; cancel it=cancel_appointment; ask about or confirm it=confirm_appointment; request a callback/message=leave_message. Use unconfirmed for an ambiguous request to change/manage an existing appointment, such as 'change something about my appointment' or 'will be late'; do NOT infer a date/time change from those alone. Use null for a clinical reason, generic new booking/follow-up, history, hypothetical or negated action. Never infer a workflow just from a keyword or a clinic policy example."
  );
